import {
  CheckAvailableDate,
  CreatePsi,
  GetAppointments,
  GetCreditCards,
  GetUserHomeInfo,
  Login,
  SyncSession,
  UpdateUser,
} from "@/app/useCases";
import { sessionClient } from "./api";
import {
  appointmentRepo,
  authRepo,
  paymentRepo,
  scheduleRepo,
  userRepo,
} from "./repositories";

export const login = new Login(authRepo, sessionClient, paymentRepo, userRepo);
export const createPsi = new CreatePsi(authRepo, sessionClient, userRepo);
export const syncSession = new SyncSession(sessionClient, userRepo, paymentRepo);
export const getUserHomeInfo = new GetUserHomeInfo(userRepo, sessionClient);
export const getAppointments = new GetAppointments(appointmentRepo, sessionClient);
export const getCreditCards = new GetCreditCards(paymentRepo);
export const checkAvailableDate = new CheckAvailableDate(scheduleRepo);
export const updateUser = new UpdateUser(userRepo, syncSession.execute);

export const useCases = {
  login,
  createPsi,
  syncSession,
  getUserHomeInfo,
  getAppointments,
  getCreditCards,
  checkAvailableDate,
  updateUser,
};
